import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-sm" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "text-sm font-bold" }
const _hoisted_5 = { class: "pl-2 text-sm" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "text-sm px-3 py-1 my-1 bg-black text-white rounded" }, "Choisir", -1)

import { useRouter } from 'vue-router'
import { useCurrentCompanyStore } from '@/stores/CurrentCompanyStore'
import { storeToRefs } from 'pinia'

export default /*#__PURE__*/_defineComponent({
  __name: 'SousCategorie',
  props: {
  description:String,
  eventTypeId:Number,
  price:Number,
  duration:Number
  },
  setup(__props) {

const props = __props;

const router = useRouter()
const {currentCompanyId } = storeToRefs(useCurrentCompanyStore())
const currentCompanyStore = useCurrentCompanyStore();





  

function goToReservation(){
  currentCompanyStore.selectedEventId = props.eventTypeId;
  currentCompanyStore.selectedEventDescription = props.description;
  currentCompanyStore.selectedEventDuration = props.duration;
  currentCompanyStore.selectedEventPrice = props.price;
  router.push(`/company/${currentCompanyId.value}/reservation`)
}  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "shadow-md border p-2 my-1 bg-white rounded cursor-pointer",
      onClick: goToReservation
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.description), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(__props.price) + " $", 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.duration * 15) + "min", 1)
        ]),
        _hoisted_6
      ])
    ])
  ]))
}
}

})